import React from "react";
import Slider from "react-slick";
import SectionTitle from "../SectionTitle";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

const Testimonial = ({ testimonialsData, testimonialsError, testimonialsIsLoading }) => {
    const settings = {
        dots: false,
        arrows: false,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const { t } = useTranslation();

    return (
        <div className="wpo-testimonial-area section-padding">
            <div className="container">
                <SectionTitle
                    subTitle={t('aboutPage.testimonial.subTitle')}
                    MainTitle={t('aboutPage.testimonial.mainTitle')}
                />
                <div className="wpo-testimonial-wrap">
                    <div className="testimonial-slider owl-carousel">
                        <Slider {...settings}>
                            {testimonialsIsLoading ? <p>{t("loading")}...</p> : testimonialsError ? <p>{t("error")}</p> : testimonialsData?.map((tesmnl, index) => (
                                <div className="wpo-testimonial-item" key={index}>
                                    <div className={`wpo-testimonial-top d-flex align-items-center`}>
                                        <div className="wpo-testimonial-img">
                                            <img src={`${process.env.REACT_APP_API_URL}/api/images/${tesmnl?.image}`} alt={tesmnl.Title} />
                                        </div>
                                        <div className="wpo-testimonial-info">
                                            <h2>{tesmnl.name}</h2>
                                            <span>{tesmnl.positionAndCompany}</span>
                                        </div>
                                    </div>
                                    <div className="wpo-testimonial-content">
                                        <p>{tesmnl.quote}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonial;
